/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { LoggerModule } from "@vlinder-web/logger-module-react";
import _ from "lodash";
import { VApplication } from "../application";
import { WalletconnectModule } from "@vlinder-web/walletconnect-module-react";
// import { WalletconnectModule } from "../modules/WalletConnect";
import {
    AFTER_LOGIN_NAV,
    BEFORE_LOGIN_NAV,
    INNER_LOGIN_NAV,
    INNER_LOGOUT_NAV,
} from "./test-data/header.nav";

const MODULE_NAME = "HeaderNavService";
const log: any = LoggerModule.getInstance();

const getWalletModule = () => {
    const vapp = VApplication.getInstance();
    const walletconnentModule = vapp.getSync(
        "services.WalletconnectModule"
    ) as WalletconnectModule;
    return walletconnentModule;
};

const getLoginService = () => {
    const loginService = VApplication.getInstance().getSync(
        "services.AuthService"
    ) as AuthService;

    if (loginService.isAuthenticated()) {
        return true;
    } else return false;
};

export class HeaderNavService {
    private static instance: HeaderNavService;
    private vapp: VApplication;
    private constructor(props: any = {}) {
        this.vapp = VApplication.getInstance();
    }
    public static getInstance(props: any = {}): HeaderNavService {
        if (!HeaderNavService.instance) {
            HeaderNavService.instance = new HeaderNavService(props);
        }
        return HeaderNavService.instance;
    }

    async getNavItems() {
        const wcModule = getWalletModule();
        const isLoggedIn = getLoginService();
        const isConnected = await wcModule.isConnected();
        console.log("getNavItems isConnected", isConnected);
        if (isConnected || isLoggedIn) {
            return AFTER_LOGIN_NAV;
        } else {
            return BEFORE_LOGIN_NAV;
        }
    }

    async getInnerNavItems() {
        const wcModule = getWalletModule();
        const isLoggedIn = getLoginService();
        const isConnected = await wcModule.isConnected();
        // wcModule.killSession();
        console.log("getInnerNavItems isConnected", isConnected);
        if (isConnected || isLoggedIn) {
            return INNER_LOGIN_NAV;
        } else {
            return INNER_LOGOUT_NAV;
        }
    }
}
